const skills = {
  loadFailed: "The skill catalog could not be loaded.",
  emptyCatalog: "No skills available yet. Once skills are published to the catalog, they show up here to install.",
  noWorkspace: "Select a workspace to see its skills.",
  installed: {
    label: "Installed",
    title: "Skill installed",
    description: {
      organization:
        "{{skill}} is now installed for the whole organization, pinned at version {{version}}.",
      product: "{{skill}} is now installed in this workspace, pinned at version {{version}}.",
      user: "{{skill}} is now installed only for you, pinned at version {{version}}.",
    },
  },
  uninstalled: {
    title: "Skill uninstalled",
    description:
      "{{skill}} is no longer served here. The record was kept, and it can be installed again.",
  },
  install: "Install",
  installer: {
    eyebrow: "Install Skill",
  },
  uninstall: "Uninstall",
  details: "Details",
  close: "Close",
  confirmInstall: "Install in this workspace",
  version: "Version {{version}}",
  publisher: {
    platform: "Prodgy",
    organization: "From the organization",
  },
  commands: {
    badge: "{{count}} command",
    badge_other: "{{count}} commands",
    title: "Commands",
    hint: "The skill's entry points — they let you start the procedure at any step.",
  },
  steps: {
    overview: "Overview",
    license: "License",
    files: "Content",
    integrations: "Tools",
    parameters: "Parameters",
    review: "Review",
    back: "Back",
    next: "Next",
  },
  scripts: {
    runsInProdgy:
      "Ships scripts — they run in the Prodgy agent. In external agents, they depend on the agent running code itself.",
  },
  license: {
    undeclared: "No license declared by the author.",
    hint: "Installing a third-party procedure in the workspace means accepting the terms of whoever wrote it.",
  },
  files: {
    binary: "Binary file — its content is not shown here.",
    loadFailed: "This file could not be read.",
  },
  review: {
    version: "Version {{version}} — this is the one pinned to this installation.",
    hint: "Publishing a new version to the catalog does not change what this workspace already uses.",
  },
  detailFailed: "The contents of this skill could not be read.",
  classifications: {
    project: "project manager",
    versioning: "version control",
    communicator: "communicator",
    crm: "CRM",
    docs: "documentation",
    llm: "AI model",
    mail: "e-mail",
    storage: "storage",
    other: "other",
  },
  platform: {
    title: "Prodgy resources this skill uses",
    hint: "They need no setup and do not block installation — they are here so you know what the skill will reach.",
    emptyGeneric: "This resource has no content in this workspace yet.",
    tool: {
      knowledge_search: "Brain",
    },
    empty: {
      knowledge_search:
        "This workspace has no active Brain. The skill will still run, but it will not find the company context.",
    },
  },
  integrations: {
    anyOfClass: "any {{classification}}",
    or: " or ",
    title: "Required tools",
    hint: "Choose which configured tool answers each one. All of them must be chosen to install.",
    none: "This skill depends on no tools.",
    choose: "Choose a tool",
    pickMany: "Pick one or more",
    pickOne: "Pick one",
    unavailable: "none configured",
    configureFirst: "configure the tool first",
    unavailableExplainer:
      "This organization has no tool configured for: {{integrations}}. Set it up under Tools and come back to install the skill.",
    pending: "{{count}} tool still to choose",
    pending_other: "{{count}} tools still to choose",
    badge: "{{count}} tool required",
    badge_other: "{{count}} tools required",
    hintShort: "Required tools: {{integrations}}",
  },
  publish: {
    action: "Import skill",
    registerTitle: "Import a skill",
    registerOnly: "Publish",
    registerAndInstall: "Publish and install",
    orgInstalledTitle: "Skill live and installed",
    orgInstalledDescription:
      "{{skill}} is in the organization store and installed. Every agent here gets it from now on.",
    orgNotInstalledTitle: "Skill live, but not installed",
    orgNotInstalledDescription:
      "{{skill}} is in the organization store, but was not installed: it declares tools with no single obvious candidate ({{missing}}). Installing needs a choice only a person can make.",
    orgPublishedTitle: "Skill is live",
    orgPublishedDescription:
      "{{skill}} is in the catalog and can be installed. Being live is not the same as serving: installing is what puts the procedure in front of an agent.",
    personalRegisteredTitle: "Skill created",
    personalRegisteredDescription: "{{skill}} is in your space and already installed. Nobody else receives it.",
    personalNotInstalledTitle: "Skill created, but not installed",
    personalNotInstalledDescription:
      "{{skill}} declares tools that are not available here: {{missing}}. It exists in your space, and nothing is serving it yet.",
    newVersion: "New version",
    onAir: "On air",
    notPublished: "Not published",
    offAir: "Off air",
    pending_one: "{{count}} not published",
    pending_other: "{{count}} not published",
    pendingHint_one:
      "There is {{count}} version registered above the one on air. Nobody receives it until it is published.",
    pendingHint_other:
      "There are {{count}} versions registered above the one on air. Nobody receives them until they are published.",
    confirmTitle: "Publish version {{version}}?",
    confirmBody:
      "It becomes the version the store offers and, in the same act, everyone who already has the skill is carried to it.",
    confirmRollback:
      "This version is older than {{current}}, which is on air — publishing it returns the catalog to its content.",
    confirmInstalls_one:
      "{{count}} installation moves to this version. Only the ones needing a human answer stay behind — a new tool to choose, a required parameter with no value.",
    confirmInstalls_other:
      "{{count}} installations move to this version. Only the ones needing a human answer stay behind — a new tool to choose, a required parameter with no value.",
    confirmNoInstalls: "No installation exists today — the version simply becomes available in the store.",
    carried_one: "{{count}} installation carried to the new version.",
    carried_other: "{{count}} installations carried to the new version.",
    keptBehind_one:
      "{{count}} stayed on the previous version: it needs an answer only a person can give.",
    keptBehind_other:
      "{{count}} stayed on the previous version: they need an answer only a person can give.",
    noChangelog: "This version carries no changelog.",
    newVersionTitle: "New version of {{skill}}",
    currentPackage: "Package of the published version",
    otherSkill:
      "This package belongs to skill \"{{got}}\", not to \"{{expected}}\". A new version must be of the same skill.",
    register: "Import",
    registerFailed: "The skill could not be imported.",
    publishVersion: "Publish this version",
    publishLatest: "Publish",
    publishedTitle: "Version published",
    publishedDescription: "{{skill}} is now served at version {{version}}.",
    publishFailed: "The version could not be published.",
    unpublish: "Unpublish",
    unpublishedTitle: "Skill is off the air",
    unpublishFailed: "The skill could not be unpublished.",
    offAirHint:
      "It was unpublished: it stays in the catalog, and no organization receives it.",
    title: "Publish a skill",
    description:
      "Drop the skill package. What it declares is read from the file; what the catalog needs is asked in the next steps.",
    stepReview: "Review",
    loading: "Loading the skill data…",
    facetsChoose: "Choose tags",
    facetsChosen_one: "{{count}} tag",
    facetsChosen_other: "{{count}} tags",
    facetsNoVocabulary:
      "No tag registered yet — create the first one below, in name:value form.",
    facetName: "name",
    facetValue: "value",
    dropHere: "Drop the skill folder or a .zip here",
    dropHint: "The folder must carry the SKILL.md at its root.",
    chooseFolder: "Choose folder",
    chooseZip: "or choose a .zip file",
    dropNothing: "Nothing was dropped.",
    dropWrongType: "Drop a folder or a .zip file.",
    readFailed: "The package could not be read.",
    replace: "Replace package",
    fileCount_one: "{{count}} file",
    fileCount_other: "{{count}} files",
    invalidPackage: "This package cannot be published as it is:",
    name: "Name",
    author: "Author",
    authorUndeclared: "Author not declared",
    ownerField: "Owner",
    ownerPlaceholder: "Who answers for this skill",
    sourceField: "Source",
    sourcePlaceholder: "https://github.com/org/repo",
    sourceLink: "Source",
    titleField: "Title",
    descriptionField: "Description",
    catalogData: "What the catalog needs",
    scope: "Scope",
    scopePlaceholder: "Choose the level",
    facets: "Tags",
    changelog: "What changed in this version",
    changelogFor: "What changed in version {{version}}",
    changelogPlaceholder: "Shown to whoever is deciding whether to update.",
    core: "Core skill",
    coreHint:
      "It applies to every organization, with no installation and no way to refuse it. Use it for the procedure the house requires of everyone.",
    integrationsHint:
      "What the skill REQUIRES to work. Most skills require nothing — declare only the procedure genuinely tied to a tool. Left empty, the step disappears from installation.",
    integrationsEmpty: "No tool required.",
    requirementId: "Requirement name",
    requirementAnyOf: "Answered by",
    requirementAnyOfPlaceholder: "Choose the tools that serve it",
    requirementAnyOfHint:
      "More than one means \"any of these\". Prefer the family (any project manager) over the product: whoever writes the skill does not know which tool the target company uses.",
    requirementReason: "What it is for",
    requirementReasonPlaceholder: "Shown to whoever is choosing the tool at install time.",
    addRequirement: "Add requirement",
    anyOfFamily: "Any {{family}}",
    parametersHint:
      "What installation asks, with the answer kept on it. Left empty, the step disappears from installation.",
    parametersEmpty: "No parameters.",
    parameterKey: "Key",
    parameterLabel: "Label",
    parameterLabelPlaceholder: "How the field shows up at install time",
    parameterType: "Type",
    parameterDefault: "Default value",
    parameterRequired: "Required",
    parameterOptions: "Options",
    parameterHelp: "Help text",
    parameterHelpPlaceholder: "One line under the field, explaining what is answered.",
    typeEnum: "List of options",
    typeText: "Free text",
    typeNumber: "Number",
    typeBoolean: "Yes or no",
    preferEnum:
      "Free text goes into what the agent reads. When the possible answers are known, a list of options closes that edge.",
    addParameter: "Add parameter",
    confirm: "Publish",
    doneTitle: "Skill published",
    doneDescription: "{{skill}} is in the catalog.",
    failed: "The skill could not be published.",
  },
  admin: {
    searchPlaceholder: "Search by name, subject, provider or tag...",
    columnName: "Skill",
    columnScope: "Installs at",
    columnVersion: "Version",
    columnInstalls: "Installations",
    saved: "Saved",
    saveFailed: "The change could not be saved.",
    dangerZone: "Danger zone",
    inactivate: "Inactivate",
    inactivateHint_one:
      "The skill leaves the catalog and stops being served. The {{count}} installation that exists keeps its record and finds the skill refused on the next run, with the reason below. Nothing is deleted.",
    inactivateHint_other:
      "The skill leaves the catalog and stops being served. The {{count}} installations that exist keep their records and find the skill refused on the next run, with the reason below. Nothing is deleted.",
    inactiveNow: "This skill is inactive. Reason: {{reason}}",
    reactivate: "Put back in the catalog",
    reasonPlaceholder: "Why is it leaving? This text reaches whoever installed it.",
    reasonRequired: "The reason is required — a skill that disappears without one leaves people guessing.",
    details: "Details",
    columnActions: "Actions",
    makeCore: "Make core",
    removeCore: "Remove core",
    columnStatus: "Status",
    ofVersions_one: "of {{count}}",
    ofVersions_other: "of {{count}}",
    notLive: "Not live",
    compare: "Compare versions",
    showVersion: "Showing version",
    needTwoVersions: "Comparing needs at least two published versions.",
    comparingFile: "Comparing {{path}}",
    core: "Core",
    corePromoted: "Skill promoted to core",
    coreDemoted: "Skill is no longer core",
    coreFailed: "The core setting could not be changed.",
    corePromptTitle: "Make this skill core?",
    corePromptBody:
      "{{skill}} will be served to EVERY organization right away, without being installed — and no organization can refuse it. Core skills also carry no answered parameters and no chosen tools, because there is no installation to hold them.",
    corePromptConfirm: "Make it core",
    coreHint:
      "Part of the tool. Served to every organization without being installed, and it cannot be installed — the way to take it off the air is to block it.",
    everyone: "Everyone",
    everyoneHint:
      "A core skill has no installation rows: it reaches every organization by definition, so there is nothing to count.",
    statusActive: "Published",
    statusInactive: "Inactive",
    noReason: "No reason recorded.",
    empty: "No skill published in the platform catalog yet.",
    emptySearch: "No skill matches this search.",
  },
  scope: {
    organization: "Organization",
    product: "Workspace",
    user: "Only for me",
    hint: {
      organization:
        "Applies across every workspace in the organization. Every connected agent loads its name and description at the start of the session.",
      product: "Applies to whoever works in this workspace.",
      user: "Applies only to you. Nobody else receives this skill.",
    },
    installedIn: {
      organization: "Installed for the organization",
      product: "Installed in the workspace",
      user: "Installed only for you",
    },
    manageWhereInstalled: "To change or remove it, go to the level where it was installed.",
    alreadyInstalledIn: {
      organization:
        "This skill is already installed for the organization, and reaches every workspace. Installing it twice would deliver it to the agent in duplicate.",
      product:
        "This skill is already installed in a workspace of this organization. Installing it for the organization as well would deliver it to the agent in duplicate.",
      user:
        "You already have this skill in My Skills. Installing it here would deliver it to the agent in duplicate.",
    },
  },
  update: {
    dialog: {
      title: "Change the version",
      rollbackTitle: "Restore an earlier version",
      description: "Changing version changes the procedure. See what changes before confirming.",
      rollbackDescription:
        "Going back undoes what these versions brought. See what stops applying before confirming.",
      upToDate: "This installation is already on the latest version.",
      noNotes: "No notes in this version.",
      parametersAdded: "New parameters",
      parametersRemoved: "Removed parameters",
      parametersRemovedHint: "The answers stored for these parameters will be discarded.",
      requirements: "Required tools",
      requiredWarning:
        "The new version asks for a required parameter that has not been answered yet. After updating, fill it in on the Parameters tab.",
      undone: "What stops applying",
      confirm: "Update now",
      confirmRollback: "Restore now",
    },
    action: "New version available",
    badge: "Update",
    rollback: "Restore",
    rollbackHint: "Puts this installation back on version {{version}}. Nothing is republished — only what is served here changes.",
    hint: "You are on version {{version}}. Changing version never happens on its own: a skill is a procedure the team has validated, and swapping it underneath would change the outcome with nobody having decided it.",
  },
  updated: {
    title: "Skill updated",
    description: "{{skill}} moved to version {{version}}.",
  },
  updateFailed: "The skill could not be updated.",
  mine: {
    title: "My skills",
    description:
      "Procedures that apply only to you. Nobody else receives them, and you need no approval to install them.",
    empty: "You have no skills of your own yet.",
    emptyCatalog: "No catalog skill accepts the individual level for now.",
    available: "Available to install",
    loadFailed: "Your skills could not be loaded.",
  },
  configure: "Configure",
  options: "Options",
  addJob: "Run automatically",
  selectOrganization: "Select an organization to see its skills.",
  parameters: {
    hint: "The skill needs these answers to run the way you work. They are kept with this installation.",
    required: "required",
    yes: "Yes",
    no: "No",
    none: "This skill asks for no parameters.",
    title: "Parameters",
    save: "Save parameters",
    saved: "Parameters updated",
  },
  card: {
    more: "see more",
  },
  filter: {
    searchPlaceholder: "Search by name, subject or tag",
    clearSearch: "Clear search",
    all: "All",
    store: "Store",
    installed: "Installed",
    facets: "Tags",
    clear: "Clear",
    noResults: "No skill matches the filter.",
  },
  settings: {
    tabs: {
      overview: "Overview",
      license: "License",
      content: "Content",
      integrations: "Tools",
      versions: "Versions",
      history: "History",
      security: "Security",
    },
    versions: {
      empty: "No published versions.",
      installed: "Installed",
      latest: "Latest",
    },
    history: {
      empty: "Nothing recorded yet.",
      installed: "Installed",
      uninstalled: "Uninstalled",
      hint: "This log covers what people did with this skill at this level. Prodgy does not run the skill — the agent does.",
    },
    back: "Back",
    notInstalled: "This skill is not installed here.",
    version: {
      title: "Version",
      current: "This is the latest version in the catalog.",
      outdated:
        "Version {{version}} is in the catalog. The swap never happens on its own — a skill is a procedure the team validated.",
    },
    integrations: {
      title: "Chosen tools",
    },
    tools: {
      title_one: "{{count}} tool available",
      title_other: "{{count}} tools available",
      none: "This tool publishes no operations.",
      hint: "These are the operations the skill can call. They were recorded when it was installed — a tool that gains a new operation later does not change what is already installed.",
    },
    remove: {
      title: "Remove the skill",
      hint: "The skill stops being served here immediately. The record is kept, usage history stays auditable, and it can be installed again later.",
    },
    blocked: {
      title: "Blocked skills",
      description:
        "A blocked skill stops being served across the whole organization — in every workspace and in the personal space of whoever had already installed it.",
      choose: "Choose a skill to block",
      nothingToBlock: "Every skill in the catalog is already blocked.",
      empty: "No blocked skills.",
      loadFailed: "The blocked skills could not be loaded.",
    },
    repository: {
      title: "Versioning repository",
      description:
        "Connect your own Git repository to mirror skill versions and take contributions by pull request.",
      soon: "Coming soon",
    },
  },
  installFailed: "The skill could not be installed.",
  uninstallFailed: "The skill could not be uninstalled.",
};

export default skills;
